import React, { useState } from 'react';
import PasswordInput from '../components/PasswordInput';
import { setSession } from '../services/supabaseClient';

const LoginPage = ({ onLogin, onNavigate }) => {
const [mode, setMode] = useState('login'); // login or register
const [formData, setFormData] = useState({ name: '', email: '', phone: '', password: '', confirmPassword: '' });
const [error, setError] = useState('');
const [loading, setLoading] = useState(false);

const inputStyle = {
width: '100%', padding: '12px 16px', borderRadius: '12px',
border: '2px solid #e8e4d9', backgroundColor: '#f8f7f4',
color: '#1a1a2e', outline: 'none', fontSize: '16px'
};

const callAuth = async (fn, body) => {
  const res = await fetch(`/.netlify/functions/${fn}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
  });
  const out = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(out.error || 'Något gick fel');
  return out;
};

const handleLogin = async () => {
  setError('');
  setLoading(true);
  try {
    const out = await callAuth('auth-login', { email: formData.email, password: formData.password });
    setSession(out.token);
    onLogin(out.user);
    return;
  } catch (err) {
    setError(err.message || 'Något gick fel. Försök igen.');
  }
  setLoading(false);
};

const handleRegister = async () => {
  setError('');
  if (!formData.name || !formData.email || !formData.password) { setError('Fyll i alla obligatoriska fält.'); return; }
  if (formData.password !== formData.confirmPassword) { setError('Lösenorden matchar inte.'); return; }
  if (formData.password.length < 6) { setError('Lösenordet måste vara minst 6 tecken.'); return; }
  setLoading(true);
  try {
    const out = await callAuth('auth-register', { name: formData.name, email: formData.email, phone: formData.phone, password: formData.password });
    setSession(out.token);
    onLogin(out.user);
    return;
  } catch (err) {
    setError(err.message || 'Något gick fel vid registrering. Försök igen.');
  }
  setLoading(false);
};


return (
<div className="min-h-screen flex items-center justify-center px-4 pt-20"
style={{ backgroundColor: '#f8f7f4' }}>
<div className="w-full max-w-md">

{/* Logo */}
<div className="text-center mb-8">
<div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4"
style={{ backgroundColor: '#1a1a2e' }}>
<svg width="36" height="36" viewBox="0 0 40 40">
<polygon points="20,4 24,16 37,16 27,24 31,36 20,28 9,36 13,24 3,16 16,16" fill="#C9A84C"/>
</svg>
</div>
<h1 className="text-3xl font-bold" style={{ color: '#1a1a2e' }}>GALAX</h1>
<p className="text-sm tracking-widest font-semibold" style={{ color: '#C9A84C' }}>ELITE STÄD</p>
</div>

<div className="rounded-2xl p-8"
style={{ backgroundColor: '#fff', border: '1px solid #e8e4d9', boxShadow: '0 4px 30px rgba(0,0,0,0.08)' }}>

{/* Toggle */}
<div className="flex rounded-full p-1 mb-6" style={{ backgroundColor: '#f8f7f4', border: '1px solid #e8e4d9' }}>
<button onClick={() => { setMode('login'); setError(''); }}
className="flex-1 py-2 rounded-full font-bold text-sm transition-all"
style={{ backgroundColor: mode === 'login' ? '#1a1a2e' : 'transparent', color: mode === 'login' ? '#C9A84C' : '#555' }}>
Logga In
</button>
<button onClick={() => { setMode('register'); setError(''); }}
className="flex-1 py-2 rounded-full font-bold text-sm transition-all"
style={{ backgroundColor: mode === 'register' ? '#1a1a2e' : 'transparent', color: mode === 'register' ? '#C9A84C' : '#555' }}>
Registrera
</button>
</div>

{mode === 'login' ? (
<div className="space-y-4">
<div>
<label className="block text-sm font-bold mb-2" style={{ color: '#1a1a2e' }}>Email</label>
<input type="email" value={formData.email}
onChange={(e) => setFormData(p => ({ ...p, email: e.target.value }))}
placeholder="din@email.com" style={inputStyle}
onKeyPress={(e) => e.key === 'Enter' && handleLogin()}/>
</div>
<div>
<label className="block text-sm font-bold mb-2" style={{ color: '#1a1a2e' }}>Lösenord</label>
<PasswordInput value={formData.password}
onChange={(e) => setFormData(p => ({ ...p, password: e.target.value }))}
placeholder="••••••••" style={inputStyle}
onKeyPress={(e) => e.key === 'Enter' && handleLogin()}/>
</div>
{error && <p className="text-sm" style={{ color: '#dc2626' }}>{error}</p>}
<button onClick={handleLogin} disabled={loading}
className="w-full py-3 rounded-full font-bold transition-all hover:scale-105"
style={{ backgroundColor: '#1a1a2e', color: '#C9A84C', border: '2px solid #C9A84C' }}>
{loading ? 'Loggar in...' : 'Logga In'}
</button>
<p className="text-center text-sm" style={{ color: '#888' }}>
Inget konto?{' '}
<button onClick={() => setMode('register')} className="font-bold" style={{ color: '#C9A84C' }}>
Registrera dig
</button>
</p>
</div>
) : (
<div className="space-y-4">
<div>
<label className="block text-sm font-bold mb-2" style={{ color: '#1a1a2e' }}>Namn *</label>
<input type="text" value={formData.name}
onChange={(e) => setFormData(p => ({ ...p, name: e.target.value }))}
placeholder="Anna Andersson" style={inputStyle}/>
</div>
<div>
<label className="block text-sm font-bold mb-2" style={{ color: '#1a1a2e' }}>Email *</label>
<input type="email" value={formData.email}
onChange={(e) => setFormData(p => ({ ...p, email: e.target.value }))}
placeholder="din@email.com" style={inputStyle}/>
</div>
<div>
<label className="block text-sm font-bold mb-2" style={{ color: '#1a1a2e' }}>Telefon</label>
<input type="tel" value={formData.phone}
onChange={(e) => setFormData(p => ({ ...p, phone: e.target.value }))}
placeholder="070-XXX XX XX" style={inputStyle}/>
</div>
<div>
<label className="block text-sm font-bold mb-2" style={{ color: '#1a1a2e' }}>Lösenord *</label>
<PasswordInput value={formData.password}
onChange={(e) => setFormData(p => ({ ...p, password: e.target.value }))}
placeholder="Minst 6 tecken" style={inputStyle}/>
</div>
<div>
<label className="block text-sm font-bold mb-2" style={{ color: '#1a1a2e' }}>Bekräfta lösenord *</label>
<PasswordInput value={formData.confirmPassword}
onChange={(e) => setFormData(p => ({ ...p, confirmPassword: e.target.value }))}
placeholder="Upprepa lösenord" style={inputStyle}/>
</div>
{error && <p className="text-sm" style={{ color: '#dc2626' }}>{error}</p>}
<button onClick={handleRegister} disabled={loading}
className="w-full py-3 rounded-full font-bold transition-all hover:scale-105"
style={{ backgroundColor: '#1a1a2e', color: '#C9A84C', border: '2px solid #C9A84C' }}>
{loading ? 'Registrerar...' : 'Skapa Konto'}
</button>
<p className="text-center text-sm" style={{ color: '#888' }}>
Redan konto?{' '}
<button onClick={() => setMode('login')} className="font-bold" style={{ color: '#C9A84C' }}>
Logga in
</button>
</p>
</div>
)}
</div>
</div>
</div>
);
};

export default LoginPage;